import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { IonSpinner } from '@ionic/angular/standalone';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-google-callback',
  standalone: true,
  imports: [IonSpinner, RouterLink],
  templateUrl: './google-callback.component.html',
  styleUrls: ['./google-callback.component.scss']
})
export class GoogleCallbackComponent implements OnInit {
  errorMessage = '';

  constructor(
    private readonly authService: AuthService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    const handoff = this.route.snapshot.queryParamMap.get('handoff');
    if (!handoff) {
      this.errorMessage = 'This Google sign-in link is incomplete. Please try again.';
      return;
    }
    this.authService.completeGoogleSignIn(handoff).subscribe({
      next: (response) => {
        if (response.success) {
          const returnUrl = response.returnUrl && response.returnUrl.startsWith('/') && !response.returnUrl.startsWith('//')
            ? response.returnUrl
            : '/';
          void this.router.navigateByUrl(returnUrl);
        }
      },
      error: (error) => {
        const payloadMessage = error?.error?.error?.message ?? error?.error?.message;
        this.errorMessage = typeof payloadMessage === 'string' && payloadMessage.trim()
          ? payloadMessage
          : 'This Google sign-in link has expired. Please sign in again.';
      }
    });
  }
}
